import { SCORING_PRIORITIES, type LeadPriorityScore } from "../../leads/types/lead-priority";
import type { TeamLeadScoringCriteria } from "../types/team-list-item";

/** Every scoring rule assigned to a team, mapped to the priority tier it is assigned under. */
export const getTeamScoringSelection = (
    criteria: TeamLeadScoringCriteria | undefined,
): ReadonlyMap<string, LeadPriorityScore> =>
    new Map(
        SCORING_PRIORITIES.flatMap((priority) =>
            (criteria?.rules[priority] ?? []).flatMap((rule) => (rule.id ? [[rule.id, priority] as const] : [])),
        ),
    );
